import Vue from 'vue'

Vue.component("ImageFilter", () => import("@/components/ImageFilter.vue"))
Vue.component("ImagePreview", () => import("@/components/ImagePreview.vue"))
Vue.component("Uploader", () => import("@/components/Uploader.vue"))